export enum ConfirmationTypeEnum {
  REGISTRY = 'REGISTRY',
  MFA = 'MFA',
  CHANGE_EMAIL = 'CHANGE_EMAIL',
  CHANGE_PHONE_NUMBER = 'CHANGE_PHONE_NUMBER',
  VERIFY_PHONE_NUMBER = 'VERIFY_PHONE_NUMBER',
  CHANGE_PASSWORD = 'CHANGE_PASSWORD',
  CASHOUT = 'CASHOUT',
}
